export default __webpack_public_path__ + "static/media/afnan.6a10c14c.png";